export default {
  path: "/store",
  name: "store",
  component: () => import("../views/Store.vue"),
  meta: {}
};
